/* eslint-disable max-len */
import React from 'react'
import BaseIcon from './BaseIcon'

class CobraIcon extends BaseIcon {
  static defaultProps = {
    width: 34,
    height: 34,
    viewBox: '0 0 34 34',
  }

  render() {
    return (
      <svg {...this.getSvgProps()}>
        <path
          d='M12.1.56V9L4.87 4.6.04 12.36l7.9 4.85-7.9 4.9 4.83 7.8 7.23-4.4V34h9.2v-8.5l7.24 4.44 4.83-7.8-7.9-4.83 7.9-4.8-4.83-7.8L21.3 9V.57h-9.2zm4.8 5.5l.04 1.23c-.24-.1-.5-.1-.72-.1l.03-1.2h.66zm.2 1.54c.02.3-.13.52-.68.6-.5.17-.27.67.03.84.68.33 1.2.67 1.5 1.17.16.5.06.9-.3 1.2-.04.1-.1.1-.16.1h-.2c-.2-.5-.5-.9-.9-1-1.2-.3-1.8-1.5-.9-2.5.3-.3.9-.5 1.5-.3zm-.13.7l.02.74-.5-.22-.1-.05c-.1-.06-.1-.14-.2-.2v-.12l.16-.03.3-.12zm-.58 2.32c.3.08.5.35.6.82v2.3c-.6-.14-1.1-.38-1.1-.68v-2.54l.2.1zm-.7.72v1.72c0 .62.9.9 1.5 1 1 .18 1.8.8 1.8 1.6.1.9-.6 1.7-1.7 2.14v-1.85c-.1-.36-.4-.53-.7-.6-1.4-.3-2.8-1.18-2.6-2.43.1-.7.6-1.3 1.5-1.58zm1 4.28c.1.04.3.1.4.2l.1 4.3-.7-.22c-.6-.2-.7-.3-.6-.4v-2.42c0-.08-.1-.13-.1-.18v-1.53c.2.1.5.2.8.25zm-1.1 1.45v2.4c-.1.63 1.4.68 2.3 1.27.8.56 1.4 1.5 1.4 2.46-.1 1.1-.5 2.16-1.8 2.78-1.6.54-2.6-.02-3.4-1.17.82-.6 1.9-.9 3.1-.9.5-.6.3-1.3-.7-1.8-1.14-.5-2.8-1-2.98-2.3-.14-1.1.36-2.1 1.95-2.7zm.9 5.25c.3.17.6.38.7.6v.66l-.1.1H17c-.45 0-.88.07-1.27.2l.05-1.96.9.4zm1 5.2c0 .58-.5 1.04-1.1 1.04-.6 0-1.1-.46-1.1-1.04 0-.57.5-1.03 1.1-1.03.6 0 1.1.4 1.1 1z'
          {...this.getPathProps()}
        />
      </svg>
    )
  }
}

export default CobraIcon
